<template>
  <div class="external-login" :class="screenHeight < 700 ? 'small' : ''">
    <div class="page-main">
      <header></header>
      <main class="main-container clearfix">
        <div class="login-form">
          <div class="form-header">
            <selectLanguage
            :isShow="true"
            :isExternal="true"
            :userType="2"
            :url="setlanguageExternalNologin"
            />
            <div class="welcome">
              <img class="logo" alt="Logo" width="300" src="../../assets/images/external/logo.png">
              <h1>{{$t('Hello')}}</h1>
              <h3>{{$t('WelcomeSystem')}}</h3>
            </div>
          </div>
          <div class="form-content">
            <h2 class="form-title">{{$t('PleaseLogin')}}</h2>
            <div class="form-group">
              <i class="iconfont icon-user"></i>
              <input type="text" @keyup.enter="login" name="tel-mail" class="form-control" v-model="name" :placeholder="$t('PleasenumberOrEmail')" @blur="checkName">
              <label class="error-msg" v-show="errorMsgName">{{errorName}}</label>
            </div>
            <div class="form-group">
              <i class="iconfont icon-lock"></i>
              <div class="row">
                <div class="col-7">
                  <input type="text" @keyup.13="login" name="code" class="form-control" v-model="code" :placeholder="$t('verificationCode')" @blur="checkCode">
                  <label class="error-msg" v-show="errorMsgCode">{{errorCode}}</label>
                </div>
                <div class="col-5">
                  <button type="button" class="btn btn-light" @click="sendVerificationCode" :disabled="sendMsg">{{sendMsg ? countdown + this.$t('ResendAfter') : this.$t('GetVerificationCode')}}</button>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button type="button" class="btn btn-gradient" @click="login">{{$t('PleaseLogin')}}</button>
            </div>
          </div>
        </div>
      </main>
      <footerExternal :isLoginPage="true"></footerExternal>
    </div>
    <div class="overlay"></div>
    <transition name="fade">
      <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTipText" @cancel="modalTip = false"></alertModal>
    </transition>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>

    <!-- 隐私弹窗 -->
    <div v-if="showPrivacyNotice">
      <div class="maskLayer"></div>
      <div class="privacy-notice-modal">
        <div class="privacy-content">
          <h1>访客隐私通知</h1>
          <p class="updateTime">更新时间：2025年8月19日</p>
          <p>可口可乐饮料（上海）有限公司（以下简称“可口可乐”或“我们”）充分尊重个人隐私，保障个人信息主体在适用法律法规下享有的各项权利。本《访客隐私通知》（以下简称“《通知》”）旨在说明我们如何收集和处理访客（以下简称“访客”或“您”）的个人信息，以及访客所享有的个人信息主体权利。</p>

          <div class="section">
              <h2>一、我们为什么收集和处理您的个人信息？</h2>
              <p>在您登记访客信息和预约访问过程中，我们可能会收集和处理您的个人信息，以实现下列目的：</p>
              <ul>
                  <li>管理对可口可乐设施、场所和人员的访问；</li>
                  <li>登记并核实访客身份，确认访问事由、日期和时间，为您完成访问预约；</li>
                  <li>就您的预约访问与您沟通联系；</li>
                  <li>允许访客进入和使用可口可乐的已批准的开放的设施、场所和资源，并记录相关情况，防止和调查未经授权的访问；</li>
                  <li>保护访客以及可口可乐设施、场所和人员的安全，防止财产损失，并协助监管部门的相关调查。</li>
              </ul>
          </div>

          <div class="section">
              <h2>二、我们收集和处理您的哪些个人信息？</h2>
              <p>出于上述目的，我们可能会根据具体场景的需要，收集和处理您的下列个人信息：</p>
              <ul>
                  <li>个人基本资料：【姓名、手机号或办公电话、公司电子邮件地址】</li>
                  <li>个人工作信息：【公司名称、工作地址、职位】</li>
                  <li>其他个人信息：【访问地点、日期和时间，车牌号】</li>
              </ul>
              <p>我们可能对您的上述个人信息进行存储、使用、加工、提供和删除等处理活动。</p>
          </div>

          <div class="section">
              <h2>三、我们如何存储您的个人信息？</h2>
              <p>我们仅在适用法律法规所允许的期限以及实现上文所述目的所需的最短期限内存储您的个人信息。我们将采取适当且可行的技术和管理措施，保障个人信息在存储过程中的安全。当您所在的公司不再与我们开展业务合作，或您不再担任访客后，您的个人信息将被及时删除或进行匿名化处理，除非适用法律法规允许我们将您的个人信息保存更长时间。</p>
          </div>

          <div class="section">
              <h2>四、跨境传输您的个人信息</h2>
              <p>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
              <p>如果我们需要将您的个人信息传输至中国境外，我们会通过适用法律法规所要求的跨境传输机制向中国境外传输您的个人信息，并将采取必要措施，保障境外接收方处理个人信息的活动达到中国法律规定的个人信息保护标准。</p>
          </div>

          <div class="section">
              <h2>五、向第三方提供您的个人信息</h2>
              <p>为了实现上文所述目的，我们可能需要将您的上述个人信息提供给我们的技术服务提供商（宁波思艾特软件有限公司）。该等实体可能对您的相关个人信息进行存储、使用、加工、提供和删除等处理活动。</p>
              <p>如果我们因合并、分立、解散、被宣告破产等原因需要转移您的个人信息，我们会向您告知接收方的名称和联系方式。我们将确保接收方继续履行个人信息保护的相关义务。</p>
          </div>

          <div class="section">
              <h2>六、您享有的个人信息主体权利</h2>
              <p>您享有适用法律法规所规定的个人信息主体权利，包括知情权、决定权、查阅复制权、删除权，更正、补充个人信息的权利，将个人信息转移至其他个人信息处理者的权利，以及限制或者拒绝我们对您个人信息进行处理的权利。</p>
              <p>如果您希望行使您在适用法律法规下享有的权利，请参见“如何联系我们”章节联系我们。</p>
          </div>

          <div class="section">
              <h2>七、如何联系我们</h2>
              <p>如果您对上述内容有任何疑问，或您希望行使您在适用法律法规下享有的权利请联系 <a href="mailto:coke-visitor-support@ciandt.com">coke-visitor-support@ciandt.com</a>，我们在中国的办公地址是上海闵行区紫竹科学园区紫月路1188号。</p>
          </div>
        </div>
        <div class="privacy-actions">
          <button class="btn btn-gradient" @click="agreePrivacy">同意</button>
          <button class="btn btn-light" @click="cancelPrivacy">拒绝</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selectLanguage from '@/components/selectLanguage.vue';
import alertModal from '@/components/alertModal.vue';
import footerExternal from '@/components/footerExternal.vue';
import Loading from 'vue-loading-overlay';

import { API } from '@/config/config';
import cokeStorage, { checkNested, regExp } from '@/utils/utils';
import { sendVerificationCodeExternal, setLanguage } from '@/utils/api';
import myAuth from '@/utils/auth';

export default {
  name: 'ExternalLogin',
  components: {
    selectLanguage,
    alertModal,
    footerExternal,
    Loading,
  },
  data() {
    return {
      setlanguageExternalNologin: API.setlanguageExternalNologin,
      name: '',
      errorMsgName: false,
      errorName: this.$t('PleasenumberOrEmail'),
      code: '',
      errorMsgCode: false,
      errorCode: '',
      modalTip: false,
      modalTipText: '',
      token: '',
      sendMsg: false,
      countdown: 60,
      screenHeight: window.innerHeight,
      isLoading: false,
      showPrivacyNotice: false,
      privacyAgreed: false,
    }
  },
  created: function () {
    const localeLanguage = window.localStorage.getItem('localeLanguage') === 'en' ? 'en-US' : 'zh-CN';
    setLanguage(API.setlanguageExternalNologin + localeLanguage);
  },
  watch: {
    countdown: function() {
      if (this.countdown === 0) {
        this.sendMsg = false;
      }
    },
  },
  methods: {
    checkName() {
      const nameVal = this.name;
      if (nameVal == '') {
        this.errorMsgName = true;
        this.errorName = this.$t('PleasenumberOrEmail');
      } else {
        //console.log(this.errorMsgCode)
        if (regExp.phone.test(nameVal) || regExp.email.test(nameVal)) {
          this.errorMsgName = false;
        } else {
          this.errorMsgName = true;
          this.errorName = this.$t('PleaseCorrectphoneNumberOrEmail');
        }
      }
    },
    checkCode() {
      const codeVal = this.code;
      if (codeVal == '') {
        this.errorMsgCode = true;
        this.errorCode = this.$t('verificationCode');
      } 
      else if (this.token == '' ) {
        this.errorMsgCode = true;
        this.errorCode = this.$t('verificationToken');
      }
      else {
        this.errorMsgCode = false;
      }
    },
    sendVerificationCode() {
      const nameVal = this.name;
      this.errorMsgName = nameVal == '' ? true : this.errorMsgName;
      if (!this.errorMsgName) {
        this.sendMsg = true;
        this.countdown = 60;
        this.setBtnTxt();
        sendVerificationCodeExternal(nameVal).then((res) => {
          if (res.data.status == '004') {
            this.modalTip = true;
            this.modalTipText = res.data.message;
            this.sendMsg = false;
            this.countdown = 0;
          } else if (checkNested(res, 'data', 'content', 'model')) {
            this.token = res.data.content.model.token;
            this.modalTip = true;
            this.modalTipText = res.data.content.message === null ? this.$t('sentSuccessfully') : res.data.content.message;
          }
        });
      }
    },
    setBtnTxt() {
      const t = this;
      if (t.countdown > 0) {
        setTimeout(function() {
          t.countdown --;
          t.setBtnTxt();
        },1000);
      }
    },
    login() {
      const _this = this;
      const nameVal = _this.name;
      const codeVal = _this.code;
      const redirect_uri = _this.$route.query.redirect_uri == undefined ? '/external/detailIndex/0/0' : _this.$route.query.redirect_uri;
      const culture = window.localStorage.getItem('localeLanguage') === 'en' ? 'en-US' : 'zh-CN';
      const url = API.setlanguageExternal + culture;
      var query = _this.$route.query;
      _this.checkName();
      _this.checkCode();
      _this.errorCode = codeVal == '' ? this.$t('verificationCode') : _this.errorCode;
      
      // 显示隐私弹窗
      if (!_this.errorMsgName && !_this.errorMsgCode) {
        if (!this.privacyAgreed) {
          this.showPrivacyNotice = true;
          return;
        }
        this.showPrivacyNotice = false;
        this.privacyAgreed = false;
      }

     if (!_this.errorMsgName && !_this.errorMsgCode) {
        _this.isLoading = true;
        myAuth.getAccessTokenExternal(_this.token, codeVal).then((model) => {
          if (query['redirect_uri']) {
            delete query['redirect_uri'];
          }
          if (query['message']) {
            delete query['message'];
          }
          myAuth.setLocalAccessToken(model);
          setLanguage(url).then((res) => {
            if (myAuth.checkToken()) {
              myAuth.getRefreshAccessTokenExternal().then((model) => {
                myAuth.setLocalAccessToken(model);
                if (model["role"] == "2") {
                  _this.$router.push({
                    path: "/external/carrier-new-application/0/0",
                    query: query
                  });
                  return;
                }
                _this.$router.push({
                  path: redirect_uri,
                  query: query,
                });
              });
            } else {
              if (model["role"] == "2") {
                _this.$router.push({
                  path: "/external/carrier-new-application/0/0",
                  query: query
                });
                return;
              }
              _this.$router.push({
                path: redirect_uri,
                query: query,
              });
            }
          });
        }).catch((error) => {
          _this.isLoading = false;
          _this.errorMsgCode = true;
          _this.errorCode = error;
        });
      }
    },

    agreePrivacy() {
      this.privacyAgreed = true;
      this.showPrivacyNotice = false;
      this.login();
    },

    cancelPrivacy() {
      this.showPrivacyNotice = false;
      this.privacyAgreed = false;
    },

  },
  mounted () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.screenHeight = window.innerHeight;
      })();
    }
  },
};
</script>
<style scoped lang="scss">
@import '../../scss/variables.scss';
.form-control,
.btn {
  padding: 12px 12px 12px 38px;
  height: 46px;
  border: 0;
  background: #f6f6f6;
  font-size: 13px;
}
.btn {
  padding: 12px 0;
  display: block;
  width: 100%;
}
.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  &:hover {
    color: #fff;
  }
}
.select-language {
  position: relative;
  z-index: 10;
  padding: 0;
}
.error-msg {
  color: #e42029;
  font-size: 11px;
  margin-top: 5px;
  margin-bottom: 0;
  width: 100%;
}
.external-login {
  height: 100vh;
  overflow: hidden;
  background: url(../../assets/images/external/bg.jpg) no-repeat center;
  background-size: cover;
  .container {
    background: transparent;
  }
  .page-main {
    position: relative;
    z-index: 2;
    min-height: 100vh;
    height: 100%;
  }
  main {
    color: #fff;
    max-height: 100%;
    overflow: hidden;
    h1 {
      font-size: 35px;
      font-weight: bold;
      margin: 20px 0;
    }
    h3 {
      font-size: 22px;
      margin-bottom: 20px;
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.9;
    background-color: #3d3d3d;
    z-index: 1;
  }
  @include respond-to('sm-max') {
    background: transparent;
    main {
      color: #4a4a4a;
      h1 {
        font-size: 26px;
        margin-bottom: 10px;
      }
      h3 {
        font-size: 14px;
      }
    }
    .overlay {
      display: none;
    }
  }
  @include respond-to('ml') {
    background: transparent;
    main {
      color: #4a4a4a;
      h1 {
        font-size: 26px;
        margin-bottom: 10px;
      }
      h3 {
        font-size: 14px;
      }
    }
    .overlay {
      display: none;
    }
  }
}
.login-form {
  width: 380px;
  height: 504px;
  border-radius: 4px;
  background-color: #fff;
  position: relative;
  padding: 30px;
  color: #4a4a4a;
  float: right;
  &:before,
  &:after {
    content: '';
    position: absolute;
  }
  &:before {
    right: 0;
    bottom: 0;
    width: 180px;
    height: 99px;
    background: url(../../assets/images/external/invalid-name_4@2x.png);
    background-size: 100% 100%;
  }
  &:after {
    left: 28px;
    bottom: 20px;
    width: 61px;
    height: 61px;
    background: url(../../assets/images/external/invalid-name_5@2x.png);
    background-size: 100% 100%;
  }
  .form-header {
    height: 112px;
    &:before {
      right: 0;
      width: 192px;
      height: 106px;
      background: url(../../assets/images/external/copy@2x.png);
      background-size: 100% 100%;
    }
    &:after {
      left: 0;
      width: 235px;
      height: 112px;
      background: url(../../assets/images/external/copy-2@2x.png);
      background-size: 100% 100%;
    }
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
    }
  }
  .welcome {
    position: absolute;
    left: -370px;
    width: 370px;
    top: 50%;
    transform: translate(0,-50%);
    color: #fff;
    .logo {
      padding-bottom: 60px;
    }
    @include respond-to('xl') {
      left: -580px;
      width: 580px;
    }
  }
  .form-title {
    font-size: 26px;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 30px;
  }
  .form-content {
    border-radius: 4px;
    padding: 15px;
    box-shadow: 0 0 25px rgba(100,100,100,.15);
  }
  .form-group {
    position: relative;
    font-size: 13px;
    i {
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 9;
    }
    .icon-user {
      width: 16px;
      overflow: hidden;
    }
    .icon-lock {
      font-size: 18px;
    }
    .col-5 {
      padding-left: 10px;
    }
    .btn {
      color: #929292;
    }
  }
  .form-action {
    .btn {
      font-size: 15px;
      font-weight: bold;
    }
  }
  @include respond-to('sm-max') {
    width: 85%;
    height: auto;
    margin: 0 auto;
    border-radius: 0;
    float: none;
    position: static;
    padding: 0;
    .form-header {
      height: auto;
      padding: 30px 0 0;
      &:before {
        right: 0;
        width: 185px;
        height: 114px;
        background: url(../../assets/images/external/invalid-name@2x.png);
        background-size: 100% 100%;
      }
      &:after {
        left: 0;
        width: 278px;
        height: 134px;
        background: url(../../assets/images/external/invalid-name_3@2x.png);
        background-size: 100% 100%;
      }
    }
    .form-title {
      display: none;
    }
    .welcome {
      position: relative;
      z-index: 9;
      top: -24px;
      margin-bottom: -24px;
      left: 0;
      width: 100%;
      transform: none;
      color: #4a4a4a;
      .logo {
        width: 133px;
      }
    }
  }
  @include respond-to('ml') {
    width: 85%;
    height: auto;
    margin: 0 auto;
    border-radius: 0;
    float: none;
    position: static;
    padding: 0;
    .form-header {
      height: auto;
      padding: 30px 0 0;
      &:before {
        right: 0;
        width: 185px;
        height: 114px;
        background: url(../../assets/images/external/invalid-name@2x.png);
        background-size: 100% 100%;
      }
      &:after {
        left: 0;
        width: 278px;
        height: 134px;
        background: url(../../assets/images/external/invalid-name_3@2x.png);
        background-size: 100% 100%;
      }
    }
    .form-title {
      display: none;
    }
    .welcome {
      position: relative;
      z-index: 9;
      top: -24px;
      margin-bottom: -24px;
      left: 0;
      width: 100%;
      transform: none;
      color: #4a4a4a;
      .logo {
        width: 133px;
      }
    }
  }
}
.main-container {
  width: 750px;
  position: absolute;
  top: 43%;
  left: 50%;
  transform: translate(-50%,-50%);
  @include respond-to('xl') {
    width: 960px;
  }
  @include respond-to('sm-max') {
    padding-bottom: 110px;
    position: static;
    transform: none;
    width: 100%;
  }
  @include respond-to('ml') {
    padding-bottom: 110px;
    position: static;
    transform: none;
    width: 100%;
  }
}
.small {
  height: 700px;
  position: relative;
  @include respond-to('sm-max') {
    height: auto;
  }
  @include respond-to('ml') {
    height: auto;
  }
}

.maskLayer{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 9999;
}
.privacy-notice-modal {
  position: fixed;
  top: 50%; 
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 10000;
  padding: 50px 30px 0px 30px;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0,0,0,0.2);
  width: 768px;
  max-height: 85%;
  overflow-y: auto;
  @media (max-width:768px) {
    width: 100%;
    max-height: unset;
    height: 100%;
    border-radius: unset;
  }
}
.privacy-content {
  h1{
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    margin: 0 0 40px 0;
  }
  h2{
    font-size: 16px;
    font-weight: bold;
    margin: 16px 0;
  }
  p{
    font-size: 14px;
    line-height: 1.5;
  }
  ul{
    padding-left: 37px;
    margin-bottom: 15px;
  }
  .updateTime{
    text-align: right;
  }
}
.privacy-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  position: sticky;
  bottom: 0;
  padding-bottom: 30px;
  background-color: #fff;
  button {
    width: 48%;
  }
}
</style>
